import { createQueryClient } from "@shared/lib/query-client";
import { dehydrate, type QueryClient } from "@tanstack/react-query";
import { cache } from "react";

export const getServerQueryClient = cache(createQueryClient);

/**
 * Serialize a server QueryClient's cache for handoff to an AsyncBoundary /
 * HydrationBoundary in a route loader.
 *
 * Uses `structuredClone` rather than `JSON.parse(JSON.stringify(...))`: the
 * latter silently drops `undefined`, `Date`, `Map`, and other non-JSON values
 * from the dehydrated cache, which corrupts hydrated query data.
 *
 * @example
 * ```ts
 * const queryClient = getServerQueryClient();
 * await queryClient.ensureQueryData(orpc.items.list.queryOptions({ input }));
 * return { dehydratedState: dehydrateForLoader(queryClient) };
 * ```
 */
export function dehydrateForLoader(queryClient: QueryClient) {
	return structuredClone(dehydrate(queryClient));
}
